"use strict";
/* Auto Generated */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonationType = void 0;
var DonationType;
(function (DonationType) {
    DonationType[DonationType["unknown"] = 0] = "unknown";
    DonationType[DonationType["paypal"] = 1] = "paypal";
    DonationType[DonationType["braveRewards"] = 2] = "braveRewards";
    DonationType[DonationType["buyMeACoffee"] = 3] = "buyMeACoffee";
    DonationType[DonationType["koFi"] = 4] = "koFi";
    DonationType[DonationType["patreon"] = 5] = "patreon";
    DonationType[DonationType["googlePay"] = 6] = "googlePay";
    DonationType[DonationType["applePay"] = 7] = "applePay";
    DonationType[DonationType["openCollective"] = 8] = "openCollective";
})(DonationType = exports.DonationType || (exports.DonationType = {}));
